module.exports = __webpack_public_path__ + "img/portrait-035.6ab90f93.jpg";